import React from 'react';
import { Crown } from 'lucide-react';
import { getPlanStyle } from '../../utils/planStyles';

export default function OpsEffectivePlan({ user, onOpen }) {
  const plan = user.effective_plan || user.plan || 'free';
  return <div>
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize ${getPlanStyle(plan).badge}`}>
      <Crown className="w-3 h-3 mr-1" />{plan.replace(/_/g, ' ')}
    </span>
    {user.plan_source === 'organization' && <button type="button" onClick={() => onOpen(user, 'subscription')}
      className="block text-xs text-blue-700 mt-2 hover:underline">
      Included in {user.organization_name || 'organization'} subscription
    </button>}
  </div>;
}
